<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Warning
      </div>
      <button
        class="ac-close-button"
        type="button"
        @click="toggleModal(false)"
      >
        <img
          src="../../assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div>If you leave now you will lose your unsaved changes.</div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        type="button"
        @click="leaveAnyway"
      >
        <span class="warning-settings-leave-anyway">
          Leave without saving
        </span>
      </button>
      <button
        class="ac-form-button"
        type="button"
        @click="goBackAndSave"
      >
        <span class="warning-settings-go-back">
          Go back and save changes
        </span>
      </button>
    </div>
  </div>
</template>
<script>

import partnerSettingsMixin from '../../mixins/partnerSettingsMixin';
import settingMixin from '../../mixins/settingMixin';

export default {
  name: 'UnsavedChangesWarning',
  mixins: [partnerSettingsMixin, settingMixin],
  data() {
    return {
      continue: false,
    };
  },
  methods: {
    leaveAnyway() {
      this.changePartnerSettingsValue('showWarningOnExit', false);
      this.toggleModal(false);
    },
    goBackAndSave() {
      this.changePartnerSettingsValue('showWarningOnExit', false);
      this.changePartnerSettingsValue('warningTab', '');
      this.changeSettingValue('warningDetailTab', '');
      this.toggleModal(false);
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/variables.scss';

.warning-settings-leave-anyway {
  color: $WHITE;
  font-size: 14px;
  font-weight: bold;
}
.warning-settings-go-back {
  background-color: $NBLUE100;
  font-size: 14px;
  font-weight: bold;
}
</style>
